import { render, staticRenderFns } from "./BrigadeCardCheckbox.vue?vue&type=template&id=afa45e02&scoped=true&"
import script from "./BrigadeCardCheckbox.vue?vue&type=script&lang=js&"
export * from "./BrigadeCardCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa45e02",
  null
  
)

export default component.exports
import {QCheckbox} from 'quasar'
component.options.components = Object.assign({QCheckbox}, component.options.components || {})
